import React, { useState } from "react";
import { AccountManagement } from "components/AccountManagement/AccountManagement";
import { AccountUsers } from "components/AccountUsers/AccountUsers";
import { LogsComponent } from "components/Logs";
import { SettingsPageLayout } from "newui/features/Settings/components/SettingsPageLayout";
import type { TabMenuItem } from "newui/components/TabComponent/TabComponent";
import type { Company } from "newui/features/Company/types";

// Legacy Redux-connected components lack TypeScript prop typings — cast to typed wrappers
const AccountManagementTyped = AccountManagement as React.ComponentType<{ company: Company }>;
const AccountUsersTyped = AccountUsers as React.ComponentType<{ company: Company }>;
const LogsComponentTyped = LogsComponent as React.ComponentType<{ company: Company }>;

/* -------------------------------------------------------------------------- */
/* Types                                                                      */
/* -------------------------------------------------------------------------- */

interface AccountSettingsProps {
  company: Company;
  path?: string;
}

/* -------------------------------------------------------------------------- */
/* Constants                                                                  */
/* -------------------------------------------------------------------------- */

const ACCOUNTUSER = "User Management";
const PAYMENTANDTRANSACTION = "Plans & Billing";
const LOGS = "Activity Log";

const TAB_MENU: TabMenuItem[] = [
  {
    id: 'user-management',
    name: ACCOUNTUSER,
    showBadge: false,
    total: 0,
  },
  {
    id: 'plans-billing',
    name: PAYMENTANDTRANSACTION,
    showBadge: false,
    total: 0,
  },
  {
    id: 'activity-log',
    name: LOGS,
    showBadge: false,
    total: 0,
  },
];

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export const AccountSettings: React.FC<AccountSettingsProps> = ({ company }) => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const tab = params.get("tab");

  const [currentTab, setCurrentTab] = useState<string>(tab || ACCOUNTUSER);

  const changeActiveTab = (name: string, _id: string): void => {
    setCurrentTab(name);
  };

  return (
    <SettingsPageLayout
      heading="Account Settings"
      tabs={TAB_MENU}
      activeTab={currentTab}
      onTabChange={changeActiveTab}
    >
      {currentTab === ACCOUNTUSER && <AccountUsersTyped company={company} />}
      {currentTab === PAYMENTANDTRANSACTION && <AccountManagementTyped company={company} />}
      {currentTab === LOGS && <LogsComponentTyped company={company} />}
    </SettingsPageLayout>
  );
};
